import { YodaFieldValue } from 'services/yodaForm/yodaForm.types';

export const transformSpeakerProfile = (data: YodaFieldValue) => {
  const imageToDB = data.image?.map((item: { id: string }) => item.id);
  return data.image ? { ...data, image: imageToDB } : data;
};
